import { GetterTree } from "vuex";
import {
	OpenAccountInvoice,
	OpenAccountLegalEntity, OpenAccountRequestData, OpenAccountState
} from "@/feature/OpenAccount/store/interface";
import { IStoreRootState } from "@/store/interface";
import { OpenAccountGetter } from "@/feature/OpenAccount/store/constants";
import { mapOpenAccountInvoice, mapOpenAccountInvoices } from "@/feature/OpenAccount/store/utils";
import { InvoiceListItem } from "@/components/List/IBInvoiceList/interface";
import { OpenAccountFormStep } from "@/feature/OpenAccount/mixins/interface";
import $t from '@/plugins/i18n/i18n';

export default <GetterTree<OpenAccountState, IStoreRootState>> {

	[OpenAccountGetter.invoiceList]: ({
		invoiceList
	}): InvoiceListItem[] => mapOpenAccountInvoices(
		invoiceList
	),

	[OpenAccountGetter.invoiceItem]: ({
		invoice
	}): InvoiceListItem => mapOpenAccountInvoice(
		invoice
	),

	[OpenAccountGetter.invoice]: ({
		invoice
	}): OpenAccountInvoice | null => invoice,

	[OpenAccountGetter.step]: ({
		step
	}): OpenAccountFormStep => step,

	[OpenAccountGetter.phoneNumber]: ({
		phoneNumber
	}): string => phoneNumber,

	[OpenAccountGetter.requestData]: ({
		requestData
	}): OpenAccountRequestData | null => requestData,

	[OpenAccountGetter.legalEntity]: ({
		legalEntity
	}): OpenAccountLegalEntity | null => legalEntity,

	[OpenAccountGetter.legalEntityLoading]: ({
		legalEntityLoading
	}): boolean => legalEntityLoading,

	[OpenAccountGetter.legalEntityLoadingHint]: ({
		legalEntityLoadingHint
	}): string => legalEntityLoadingHint,

	[OpenAccountGetter.legalEntityLoadingHintList]: (): string[] =>
		$t.t('openAccount.legalEntityLoadingHintList') as any,

}